/**
 * Movie Explore Service
 * API calls for constellation-based film discovery
 */

import { post, get, del } from '../lib/api-client';
import type {
  MovieExploreRequest,
  MovieExploreResponse,
  SavedMovieConstellation,
} from '../types/movie-explore.types';

/**
 * Generate film recommendations from constellation
 */
export async function generateMovieExplore(
  request: MovieExploreRequest
): Promise<MovieExploreResponse> {
  const response = await post<MovieExploreResponse['data']>('/movies/generate', request);
  return {
    success: response.success,
    data: response.data!,
    error: response.error?.message,
  };
}

/**
 * Save movie constellation preset
 */
export async function saveMovieConstellation({
  name,
  description,
  nodes,
  vibe,
}: {
  name: string;
  description?: string;
  nodes: MovieExploreRequest['nodes'];
  vibe: MovieExploreRequest['vibe'];
}): Promise<SavedMovieConstellation> {
  const response = await post<SavedMovieConstellation>('/movies/save', {
    name,
    description,
    nodes,
    vibe,
  });
  return response.data!;
}

/**
 * Get user's saved movie constellations
 */
export async function getSavedMovieConstellations(): Promise<SavedMovieConstellation[]> {
  const response = await get<SavedMovieConstellation[]>('/movies/saved');
  return response.data || [];
}

/**
 * Delete saved movie constellation
 */
export async function deleteMovieConstellation(id: string): Promise<void> {
  await del(`/movies/saved/${id}`);
}
